export default "__VITE_ASSET__c98t1lsb__"